"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SopTaskDataConfigModal = SopTaskDataConfigModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@dnd-kit/core");
var sortable_1 = require("@dnd-kit/sortable");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var sop_library_1 = require("../../../features/apis/sop-library");
var table_1 = require("../../table");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
var data_config_draft_row_1 = require("./data-config-draft-row");
var sortable_data_config_row_1 = require("./sortable-data-config-row");
function SopTaskDataConfigModal(props) {
    var _this = this;
    var _a;
    var sopLibraryId = props.sopLibraryId, sopTask = props.sopTask, onClose = props.onClose, onChanged = props.onChanged;
    var _b = (0, react_2.useState)(""), error = _b[0], setError = _b[1];
    var _c = (0, react_2.useState)([]), rows = _c[0], setRows = _c[1];
    var _d = (0, react_2.useState)(false), isAddingRow = _d[0], setIsAddingRow = _d[1];
    var _e = (0, react_2.useState)(false), isBusy = _e[0], setIsBusy = _e[1];
    var requestInFlightRef = (0, react_2.useRef)(false);
    var addRow = (0, sop_library_1.useAddSopTaskDataConfigMutation)()[0];
    var updateRow = (0, sop_library_1.useUpdateSopTaskDataConfigMutation)()[0];
    var deleteRow = (0, sop_library_1.useDeleteSopTaskDataConfigMutation)()[0];
    var reorderRows = (0, sop_library_1.useReorderSopTaskDataConfigMutation)()[0];
    var sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor, { activationConstraint: { distance: 8 } }), (0, core_1.useSensor)(core_1.KeyboardSensor, { coordinateGetter: sortable_1.sortableKeyboardCoordinates }));
    (0, react_2.useEffect)(function () {
        var _a;
        setRows((_a = sopTask === null || sopTask === void 0 ? void 0 : sopTask.dataConfig) !== null && _a !== void 0 ? _a : []);
        setIsAddingRow(false);
        setError("");
    }, [sopTask]);
    var handleClose = function () {
        if (requestInFlightRef.current)
            return;
        setError("");
        onClose();
    };
    var runMutation = function (action) { return __awaiter(_this, void 0, void 0, function () {
        var response, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!sopLibraryId || !sopTask || requestInFlightRef.current)
                        return [2 /*return*/, false];
                    setError("");
                    requestInFlightRef.current = true;
                    setIsBusy(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, action()];
                case 2:
                    response = _c.sent();
                    if (!response.success) {
                        setError(response.message || "Unable to save the change. Please try again.");
                        return [2 /*return*/, false];
                    }
                    setRows((_b = response.content.dataConfig) !== null && _b !== void 0 ? _b : []);
                    onChanged === null || onChanged === void 0 ? void 0 : onChanged();
                    return [2 /*return*/, true];
                case 3:
                    _a = _c.sent();
                    setError("Unable to save the change. Please try again.");
                    return [2 /*return*/, false];
                case 4:
                    requestInFlightRef.current = false;
                    setIsBusy(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAddRow = function () {
        if (isBusy || isAddingRow)
            return;
        setIsAddingRow(true);
    };
    var handleCancelDraft = function () {
        setIsAddingRow(false);
    };
    var handleSaveDraft = function (draft) { return __awaiter(_this, void 0, void 0, function () {
        var succeeded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!sopLibraryId || !sopTask)
                        return [2 /*return*/];
                    return [4 /*yield*/, runMutation(function () { return addRow({ sopLibraryId: sopLibraryId, taskId: sopTask.id, title: draft.title, type: draft.type, units: draft.units }).unwrap(); })];
                case 1:
                    succeeded = _a.sent();
                    if (succeeded) {
                        setIsAddingRow(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveRow = function (entryId, changes) {
        if (!sopLibraryId || !sopTask)
            return;
        runMutation(function () { return updateRow(__assign({ sopLibraryId: sopLibraryId, taskId: sopTask.id, entryId: entryId }, changes)).unwrap(); });
    };
    var handleDeleteRow = function (entryId) {
        if (!sopLibraryId || !sopTask)
            return;
        runMutation(function () { return deleteRow({ sopLibraryId: sopLibraryId, taskId: sopTask.id, entryId: entryId }).unwrap(); });
    };
    var handleDragEnd = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var active, over, oldIndex, newIndex, previousRows, reordered, succeeded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    active = event.active, over = event.over;
                    if (!over || active.id === over.id || !sopLibraryId || !sopTask || requestInFlightRef.current) {
                        return [2 /*return*/];
                    }
                    oldIndex = rows.findIndex(function (row) { return row.id === active.id; });
                    newIndex = rows.findIndex(function (row) { return row.id === over.id; });
                    if (oldIndex === -1 || newIndex === -1) {
                        return [2 /*return*/];
                    }
                    previousRows = rows;
                    reordered = (0, sortable_1.arrayMove)(rows, oldIndex, newIndex);
                    setRows(reordered);
                    return [4 /*yield*/, runMutation(function () { return reorderRows({ sopLibraryId: sopLibraryId, taskId: sopTask.id, order: reordered.map(function (row) { return row.id; }) }).unwrap(); })];
                case 1:
                    succeeded = _a.sent();
                    if (!succeeded) {
                        setRows(previousRows);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: !!sopTask, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isBusy, isKeyboardDismissDisabled: isBusy, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[820px] max-h-[85vh]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isBusy, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Data Configuration \u2014 ".concat((_a = sopTask === null || sopTask === void 0 ? void 0 : sopTask.name) !== null && _a !== void 0 ? _a : "") }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-3 overflow-y-auto", children: [rows.length === 0 && !isAddingRow && (0, jsx_runtime_1.jsx)(table_1.TableEmptyState, { icon: "solar:widget-linear", message: "No data configuration found for this task." }), (rows.length > 0 || isAddingRow) && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 px-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-[18px] shrink-0" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", weight: "medium", label: "Title", className: "flex-1 min-w-0" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", weight: "medium", label: "Type", className: "flex-1 min-w-0" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", weight: "medium", label: "Units", className: "w-24 shrink-0" }), (0, jsx_runtime_1.jsx)("div", { className: "w-28 shrink-0" })] })), isAddingRow && (0, jsx_runtime_1.jsx)(data_config_draft_row_1.DataConfigDraftRow, { onSave: handleSaveDraft, onCancel: handleCancelDraft, isBusy: isBusy }), (0, jsx_runtime_1.jsx)(core_1.DndContext, { sensors: sensors, onDragEnd: handleDragEnd, children: (0, jsx_runtime_1.jsx)(sortable_1.SortableContext, { items: rows.map(function (row) { return row.id; }), strategy: sortable_1.verticalListSortingStrategy, children: (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2", children: rows.map(function (row) { return ((0, jsx_runtime_1.jsx)(sortable_data_config_row_1.SortableDataConfigRow, { entry: row, onSave: handleSaveRow, onDelete: handleDeleteRow, isBusy: isBusy }, row.id)); }) }) }) }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Add Data Point", onPress: handleAddRow, isPending: isBusy, isDisabled: isBusy || isAddingRow, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Close", onPress: handleClose, variant: "secondary", isDisabled: isBusy })] })] }) }) }) }));
}
